import React from 'react';
import { useIntl } from 'react-intl';
import { getWarehouseApiUrl } from '../../../helpers/url';
import { Capabilities } from '../../../types/warehouse/user';
import Resources from './Resources';

interface ProductResourcesProps {
    id: number;
}

const getUrl = (id: number) => getWarehouseApiUrl('products/:id/resources', { params: { id } });
const getResourceUrl = (id: number) => (resourceId: number) =>
    getWarehouseApiUrl('products/:id/resources/:resourceId', { params: { id, resourceId } });

export default ({ id }: ProductResourcesProps) => {
    const { formatMessage } = useIntl();
    const title = formatMessage({ id: 'resources.product.title', defaultMessage: 'Product resources' });

    return <Resources url={getUrl(id)} getResourceUrl={getResourceUrl(id)} title={title}
        capability={Capabilities.PRODUCTS_MANAGE} />;
}
